import * as Types from '../../App/AppPageBlock/graphql/hirer-types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HeaderFooterContextQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type HeaderFooterContextQuery = {
  __typename: 'Query';
  currentAdvertiser:
    | { __typename: 'CurrentAdvertiserContext'; seekId: string }
    | { __typename: 'MissingAdvertiserIdClaimError'; message: string };
  headerFooterContext?: {
    __typename: 'HeaderFooterContext';
    identityContext?: {
      __typename: 'IdentityHeaderContext';
      email: string;
      act?: {
        __typename: 'ActorContext';
        operatorEmail: string;
        isCsView: boolean;
      } | null;
    } | null;
    advertiser?: {
      __typename: 'AdvertiserHeaderContext';
      billingId: string;
      hasMultipleAccounts: boolean;
      isActivationPending: boolean;
      isAgency: boolean;
      name: string;
      showOnCreditHoldMessage: boolean;
      switchAccountsHref?: string | null;
      permissionOptions: {
        __typename: 'PermissionOptions';
        canCreateJobs: boolean;
        canManageBrand: boolean;
        canManageCompanyProfile: boolean;
        canManageUsers: boolean;
        canPayInvoices: boolean;
        canViewInsightsRoleReport: boolean;
        canViewInvoiceHistory: boolean;
        canViewManagerReports: boolean;
        canClaimCompanyProfile: boolean;
        canViewPremiumTalentSearch: boolean;
        canExportApplications:
          | {
              __typename: 'CanExportApplicationsResponseSuccess';
              result: boolean;
            }
          | { __typename: 'ResponseError'; error: Types.ResponseErrorReason };
      };
    } | null;
    user?: {
      __typename: 'UserHeaderContext';
      name: string;
      firstName: string;
      id: string;
    } | null;
  } | null;
};

export const HeaderFooterContextDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HeaderFooterContext' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentAdvertiser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'CurrentAdvertiserContext' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'seekId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'MissingAdvertiserIdClaimError',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerFooterContext' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityContext' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'act' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'operatorEmail' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'isCsView' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'advertiser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'billingId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasMultipleAccounts' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isActivationPending' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isAgency' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissionOptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canCreateJobs' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canManageBrand' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canManageCompanyProfile',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canManageUsers' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'canPayInvoices' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canViewInsightsRoleReport',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canViewInvoiceHistory',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canViewManagerReports',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canExportApplications',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value:
                                          'CanExportApplicationsResponseSuccess',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'result',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'ResponseError',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'error',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canClaimCompanyProfile',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'canViewPremiumTalentSearch',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'showOnCreditHoldMessage',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'switchAccountsHref' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHeaderFooterContextQuery__
 *
 * To run a query within a React component, call `useHeaderFooterContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderFooterContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderFooterContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderFooterContextQuery(
  baseOptions?: Apollo.QueryHookOptions<
    HeaderFooterContextQuery,
    HeaderFooterContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    HeaderFooterContextQuery,
    HeaderFooterContextQueryVariables
  >(HeaderFooterContextDocument, options);
}
export function useHeaderFooterContextLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HeaderFooterContextQuery,
    HeaderFooterContextQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    HeaderFooterContextQuery,
    HeaderFooterContextQueryVariables
  >(HeaderFooterContextDocument, options);
}
export function useHeaderFooterContextSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        HeaderFooterContextQuery,
        HeaderFooterContextQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    HeaderFooterContextQuery,
    HeaderFooterContextQueryVariables
  >(HeaderFooterContextDocument, options);
}
export type HeaderFooterContextQueryHookResult = ReturnType<
  typeof useHeaderFooterContextQuery
>;
export type HeaderFooterContextLazyQueryHookResult = ReturnType<
  typeof useHeaderFooterContextLazyQuery
>;
export type HeaderFooterContextSuspenseQueryHookResult = ReturnType<
  typeof useHeaderFooterContextSuspenseQuery
>;
export type HeaderFooterContextQueryResult = Apollo.QueryResult<
  HeaderFooterContextQuery,
  HeaderFooterContextQueryVariables
>;
